module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/en/1-f2f17c22ba5f96d3d56c4e1deb2df173.jpg";